module.exports = __webpack_public_path__ + "static/image/company/pc/image_conduct.jpg?4d92b70a";